import * as Adjust from '@/js/util/adjust'
import {helperIsComma, helperConverDateJST, arrangePostCodeAddHyphen} from '@/js/util/helper'
import moment from 'moment'

/**
 * APIから取得した個人情報データを,
 * 個人情報変更モーダルに合うよう整形する
 * @param {object} contract 契約情報
 * @param {object} customer 個人情報
 * @return {object|null} 整形データ
 */

export const eidtUserInputDataTransformWebApi = (contract, customer) => {
  const d = contract,
    c = customer

  if (!d && !c) return null

  // 個人情報変更モーダル データ整理
  const userForm = {
    application_date_year: d.apply_date ? moment(d.apply_date).year().toString() : null, // 申込日(年)
    application_date_month: d.apply_date ? (moment(d.apply_date).month() + 1).toString() : null, // 申込日(月)
    application_date_day: d.apply_date ? moment(d.apply_date).date().toString() : null, // 申込日(日)
    purpose_of_transaction: c.purpose_of_transaction, // 取引を行う目的
    purpose_of_transaction_other_name: c.purpose_of_transaction_other_name, // 取引を行う目的
    is_foreign_government: c.is_foreign_government, // 外国政府等重要な公的地位にある方等とのお取引に該当する
    foreign_government_company: c.foreign_government_company, // 外国政府等重要な公的地位にある方等とのお取引に該当する 国名と職名
    surname: d.surname, // 姓
    first_name: d.name, // 名
    old_surname: c.old_surname, // 旧姓
    surname_kana: d.surname_kana, // 姓(フリガナ)
    first_name_kana: d.name_kana, // 名(フリガナ)
    old_surname_kana: c.old_surname_kana, // 旧姓(カナ)
    sex_type: c.sex_type, // 性別
    birthday_year: c.birthday ? moment(c.birthday).year().toString() : null, // 生年月日(年)
    birthday_month: c.birthday ? (moment(c.birthday).month() + 1).toString() : null, // 生年月日(月)
    birthday_day: c.birthday ? moment(c.birthday).date().toString() : null, // 生年月日(日)
    post_number: arrangePostCodeAddHyphen(c.post_number), // 郵便番号
    street_address1: c.street_address1, // 住所1
    street_address2: c.street_address2, // 住所2
    street_address_kana: c.street_address1_kana, // 住所カナ(住所1のカナ)
    fixed_phone1: c.fixed_phone ? c.fixed_phone.split('-')[0] ?? null : null, // 固定電話
    fixed_phone2: c.fixed_phone ? c.fixed_phone.split('-')[1] ?? null : null, // 固定電話
    fixed_phone3: c.fixed_phone ? c.fixed_phone.split('-')[2] ?? null : null, // 固定電話
    mobile_phone1: c.mobile_phone ? c.mobile_phone.split('-')[0] ?? null : null, // 携帯電話
    mobile_phone2: c.mobile_phone ? c.mobile_phone.split('-')[1] ?? null : null, // 携帯電話
    mobile_phone3: c.mobile_phone ? c.mobile_phone.split('-')[2] ?? null : null, // 携帯電話
    family_about: c.family_about, // ご家族について
    family_about_number: c.family_about_number, // 同居人数
    family_structure: c.family_structure, // 生計同一人数
    residence_classification: c.residence_classification1, // 住居形態
    residence_period_year: c.residence_period_year, // 居住年数(年)
    loan_rent: c.loan_rent, // ローン有無
    occupation: c.occupation, // お勤め先・学校について
    occupation_other_name: c.occupation_other_name,
    student_unemployed_flg: c.student_unemployed_flg, // 無職フラグ
    householder_relation: c.householder_relation, // 世帯主との関係
    householder_income: c.householder_income, // 世帯主収入
    householder_income_type: c.householder_income_type, // 世帯主の所得種類
    householder_income_type_other_name: c.householder_income_type_other_name, // 世帯主の所得種類 その他の場合のテキスト
    householder_monthly_credit_payments: c.householder_monthly_credit_payments, // 世帯主のクレジット月間支払い額
    parents_post: arrangePostCodeAddHyphen(c.parents_post), // 実家郵便番号
    parents_address: c.parents_address1, // 実家住所
    parents_phone1: c.parents_phone ? c.parents_phone.split('-')[0] ?? null : null, // 実家固定電話番号
    parents_phone2: c.parents_phone ? c.parents_phone.split('-')[1] ?? null : null, // 実家固定電話番号
    parents_phone3: c.parents_phone ? c.parents_phone.split('-')[2] ?? null : null, // 実家固定電話番号
    parents_phone_exists: c.parents_phone ? true : false,  // 実家固定電話のチェックボックス
    parents_mobile_phone1: c.parents_mobile_phone ? c.parents_mobile_phone.split('-')[0] ?? null : null, // 実家携帯電話番号
    parents_mobile_phone2: c.parents_mobile_phone ? c.parents_mobile_phone.split('-')[1] ?? null : null, // 実家携帯電話番号
    parents_mobile_phone3: c.parents_mobile_phone ? c.parents_mobile_phone.split('-')[2] ?? null : null, // 実家携帯電話番号
    parents_mobile_exists: c.parents_mobile_phone ? true : false,  // 実家携帯電話のチェックボックス
    parents_phone_relationship: c.parents_phone_relationship,  // 実家携帯電話の続柄
    parents_phone_relationship_other_name: c.parents_phone_relationship_other_name,  // 実家携帯電話の続柄(その他)
    graduate_year: c.graduate_year, // 卒業予定(年)
    graduate_month: c.graduate_month, // 卒業予定(月)
    company_name: c.company_name, // お勤め先
    company_name_kana: c.company_name_kana, // お勤め先カナ
    company_phone1: c.company_phone ? c.company_phone.split('-')[0] ?? null : null, // お勤め先電話番号
    company_phone2: c.company_phone ? c.company_phone.split('-')[1] ?? null : null, // お勤め先電話番号
    company_phone3: c.company_phone ? c.company_phone.split('-')[2] ?? null : null, // お勤め先電話番号
    company_job_description: c.company_job_description, // 仕事内容
    company_job_description_other_name: c.company_job_description_other_name, // 仕事内容 その他の場合のテキスト
    job_department: c.job_department, // 所属部課
    dispatched_agent: c.dispatched_agent, // 出向派遣元
    company_post: arrangePostCodeAddHyphen(c.company_post), // 勤め先郵便番号
    company_address: c.company_address1, // 勤め先住所
    join_year: c.join_year, // 入社年月(年)
    join_month: c.join_month ? String(c.join_month) : null, // 入社年月(月)
    payday: c.payday ? Number(c.payday) : null, // 給料日
    company_income: c.company_income, // 税込年収
    sideline_type: c.sideline_type, // その他収入
    sideline_other_name: c.sideline_other_name, // その他収入 その他の場合のテキスト
    sideline_income: c.sideline_income, // その他収入(年額)
    is_change_customer: 0 // 変更フラグ
  }

  return userForm
}
